{
	"submitTitle": "Velg materiale",
	"summary": {
		"title": "Sammendrag",
		"declarationTypeTitle": "Erklæringstype",
		"projectReferenceTitle": "Prosjektreferanse"
	},
	"content": {
		"selectTheDeclarationTypeSection": {
			"title": "Velg erklæringstype",
			"customerProject": {
				"title": "Kundeprosjekt",
				"description": "Materialet ble brukt til et eksternt prosjekt. Nå må jeg gi en erklæring som beskriver karbonreduksjonene for kunden min."
			},
			"internalProjectOrProduct": {
				"title": "Internt prosjekt/produkt",
				"description": "Materialet ble brukt til et internt prosjekt eller produkt. Jeg må lage en erklæring for å kreve karbonreduksjonene for vår egen virksomhet."
			}
		},
		"addProjectReferenceSection": {
			"title": "Legg til prosjektreferanse",
			"subTitle": "Du må tilordne karbonreduksjoner til en prosjektreferanse som du vil opprette deklarasjonen for.",
			"projectReferencePlaceholder": "Prosjektreferanse"
		},
		"selectProjectSection": {
			"title": "Velg et prosjekt",
			"createNewProjectPlaceholder": "Opprett nytt prosjekt"
		}
	},
	"errorMessages": {
		"declarationTypeRequired": "Erklæringstype kreves",
		"projectReferenceRequired": "Prosjektreferanse er nødvendig",
		"fetchProjectsError": "Kunne ikke hente tidligere prosjekter"
	}
}
